/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

export const addOrRemoveJinglesToCollectionModelSchema = z.object({
    "jingleIds": z.array(z.string().uuid()).describe("Идентификаторы джинглов")
    })